import { Table } from "reactstrap";
import InvoiceFourHeader from "./InvoiceFourHeader";
import InvoiceFourDetail from "./InvoiceFourDetail";
import InvoiceFourTable from "./InvoiceFourTable";
import InvoiceTotal from "./InvoiceTotal";
import InvoiceFiveSign from "../Invoice-5/InvoiceFiveSign";
import { useRef } from "react";
import { InvoiceButtons } from "../Common/InvoiceButtons";

const InvoiceFourContainer = () => {
  const contentRef = useRef<HTMLDivElement | null>(null);
  return (
    <>
      <div ref={contentRef}>
        <Table style={{ width: "1075px", margin: "0 auto", background: "#fff" }} borderless>
          <tbody style={{ padding: "10px" }}>
            <tr>
              <InvoiceFourHeader />
            </tr>
            <tr>
              <InvoiceFourDetail />
            </tr>
            <tr>
              <InvoiceFourTable />
            </tr>
            <tr style={{ height: 3, width: "100%", background: "linear-gradient(90deg, #6f5a99 20.61%, #0DA759 103.6%)", display: "block", marginTop: 6 }} />
            <tr>
              <InvoiceTotal />
            </tr>
            <InvoiceFiveSign />
          </tbody>
        </Table>
      </div>
      <InvoiceButtons contentRef={contentRef} />
    </>
  );
};

export default InvoiceFourContainer;
